import type { AnalysisToken } from '@/types/sentence'
import { posStyle } from './posStyles'

interface TokenDetailProps {
  token: AnalysisToken | null
}

export function TokenDetail({ token }: TokenDetailProps) {
  if (!token) {
    return (
      <div className="rounded-xl bg-surface-bg p-6 text-center text-sm font-light text-muted">
        Hover a word to explore
      </div>
    )
  }

  const s = posStyle(token.pos)

  return (
    <div className="rounded-xl bg-surface-bg p-6">
      <div className="flex items-start gap-5">
        <span className={`text-2xl font-medium ${s.text}`}>
          {token.word}
        </span>
        <div className="flex flex-col gap-1.5 pt-1">
          <span
            className={`inline-flex self-start px-2.5 py-0.5 rounded-full text-[11px] font-medium uppercase tracking-wide border ${s.bg} ${s.border} ${s.text}`}
          >
            {s.label}
          </span>
          <span className="text-xs font-light text-muted">
            base form: {token.lemma}
          </span>
        </div>
      </div>
      {token.tags.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {token.tags.map((tag) => (
            <span
              key={tag}
              className="inline-flex items-center px-2 py-0.5 text-[11px] font-light rounded-full bg-page-bg border border-border-divider text-muted"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}
